import http from "@/utils/http";
const prefixUrl = {
  home: "/Index/api.html", // API-2
  location: "/Index/getLocationKey.html", // API-1
};
export default {
  queryHome(params = {}) {
    return http.get(prefixUrl.home, { params });
  },
  queryLocation(params = {}) {
    return http.get(prefixUrl.location, { params });
  },
};
